import { KeywordHelperType } from '../../../keyword-helper/enums/KeywordHelperType';
import { KeywordHelperContent } from '../../../keyword-helper/KeywordHelperContent';

class EnglishCourseDefinition extends KeywordHelperContent {
	public constructor() {
		super(KeywordHelperType.ENGLISH_COURSE);
	}
}

export default new EnglishCourseDefinition();
